export const TYPE_DEFAULT = 'Default'
export const TYPE_VIEW_SETTINGS = 'View Settings'
export const TYPE_USER_SETTINGS = 'User Settings'
export const TYPE_IMPORT_SETTINGS = 'Import'